const CheckedCircleIcon = ({ className }) => {
  return (
    <svg
      width="28"
      height="28"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={className}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#268771" cx="15.5" cy="15.5" r="15.5" />
        <path
          fill="#FFF"
          d="M22.24 10l-8.105 9.447-4.503-4.488L8 16.754 14.268 23 24 11.655z"
        />
      </g>
    </svg>
  );
};

export default CheckedCircleIcon;
